import type { Project } from '@/types/project';

// All three fields captured = the form collapses to the summary. The step-1
// done BADGE additionally requires a current framing (deriveStepStatuses);
// this stays fields-only so the framing card, not the form, owns that state.
export function isIdeaComplete(project: Project): boolean {
  return (
    !!project.idea?.trim() &&
    !!project.aspiration?.trim() &&
    !!project.customerSegment?.role?.trim()
  );
}
